async function downloadImage(url) {
	const filename = String(url || "").split('/').pop();

	try {
		const response = await fetch(url);
		const blob = await response.blob();
		const blobUrl = URL.createObjectURL(blob);

		const anchor = document.createElement('a');
		anchor.href = blobUrl;
		anchor.download = filename || 'downloaded-image.jpg';
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);

		// Clean up
		URL.revokeObjectURL(blobUrl);
	} catch (error) {
		try {
			const anchor = document.createElement('a');
			anchor.href = url;
			anchor.target = "_blank";
			anchor.download = filename || 'downloaded-image.jpg';
			document.body.appendChild(anchor);
			anchor.click();
			document.body.removeChild(anchor);
		} catch (err) {

		}
	}
}

export default downloadImage
